import { Pipe, PipeTransform } from '@angular/core';
import { UIState } from '../uistate.enum';

const STATE_CLASS_MAP: Record<string, string> = {
  [UIState.Primary]: 'cux-icon--primary',
  [UIState.Success]: 'cux-icon--success',
  [UIState.Info]: 'cux-icon--info',
  [UIState.Danger]: 'cux-icon--danger',
  [UIState.Muted]: 'cux-icon--muted',
  [UIState.Transparent]: 'cux-icon--white',
};

@Pipe({ name: 'iconState' })
export class IconStatePipe implements PipeTransform {
  transform(value: string): string {
    return STATE_CLASS_MAP[value] ?? '';
  }
}
